/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.parse-float.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: {
    desc: {
      type: String,
      "default": ''
    },
    rowNum: {
      type: Number,
      "default": 3
    }
  },
  data: function data() {
    return {
      more: 0,
      maxHeight: 'none'
    };
  },
  computed: {
    classObj: function classObj() {
      var className = 'ellipsis' + this.rowNum;
      var classObj = {};
      classObj[className] = this.more == 1;
      classObj['no-hide'] = this.more == 2;
      return classObj;
    }
  },
  watch: {
    desc: function desc(val) {
      if (val && val.length > 0) {
        this.judgeMore();
      }
    }
  },
  mounted: function mounted() {
    this.judgeMore();
  },
  methods: {
    moreShow: function moreShow() {
      if (this.more == 1) {
        this.more = 2;
        this.$refs.descWrap.style.maxHeight = 'none';
      } else if (this.more == 2) {
        this.more = 1;
        this.$refs.descWrap.style.maxHeight = this.maxHeight;
      }
    },
    judgeMore: function judgeMore() {
      var _this = this;

      this.$nextTick(function () {
        var vH = .36,
            mH;
        var docEl = window.document.documentElement;
        var docFont = parseFloat(docEl.style.fontSize);
        _this.$refs.descWrap.style.lineHeight = vH + 'rem';
        mH = vH * _this.rowNum;
        _this.maxHeight = mH + 'rem';
        _this.$refs.descWrap.style.maxHeight = mH + 'rem';
        mH = vH * _this.rowNum * docFont;
        console.log(mH);

        if (_this.desc && _this.desc.length > 0) {
          console.log(_this.$refs.descHtml.offsetHeight);

          if (_this.$refs.descHtml.offsetHeight > mH) {
            _this.more = 1;
          } else {
            _this.more = 0;
          }
        }
      });
    }
  }
};